import Axios from 'axios'
import csc from '@csc/csc-sdk'

import {
  CSC_IAM_AUD,
  CSC_IAM_REGISTERED_IDP,
  CSC_IAM_GUEST_IDP,
  CSC_IAM_REGISTERED_ROLE,
  CSC_IAM_GUEST_ROLE,
  CSC_IAM_ACCOUNT,
} from '@/services/Configuration'

const GUEST_TOKEN_NAME = 'guestToken'

const clearSavedGuestToken = () => {
  localStorage.removeItem(GUEST_TOKEN_NAME) // consider sessionStorage?
}

const getGuestTokenFromLocalStorage = async () => {
  let jwt = null
  const tokenOnStorage = localStorage.getItem(GUEST_TOKEN_NAME)
  if (tokenOnStorage) {
    // If the token exists, assume you're good. If not, the implementer can clear the token and retry.
    jwt = tokenOnStorage
  } else {
    const { token } = await csc.IAM().getAnonymousJwtIdpToken({ accountId: CSC_IAM_ACCOUNT, jwtIdpName: CSC_IAM_GUEST_IDP })
    jwt = token
  }

  localStorage.setItem(GUEST_TOKEN_NAME, jwt)
  return jwt
}

const getCredentialsFromJwt = async ({ jwt, isRegistered }) => await csc.IAM().assumeRoleWithJwt({
  jwtIdpName: isRegistered ? CSC_IAM_REGISTERED_IDP : CSC_IAM_GUEST_IDP,
  jwt,
  roleName: isRegistered ? CSC_IAM_REGISTERED_ROLE : CSC_IAM_GUEST_ROLE ,
  accountId: CSC_IAM_ACCOUNT
})

const getRegisteredUserCredentials = async () => {
  const { token: jwt } = (await Axios.get(`/customer/current.jwt?app_client_id=${CSC_IAM_AUD}`)).data
  const credentials = await getCredentialsFromJwt({ jwt, isRegistered: true })
  clearSavedGuestToken() //if you are successfully signed in, you don't need a token
  return credentials
}

const getGuestUserCredentials  = async () => {
  try {
    const jwt = await getGuestTokenFromLocalStorage()
    return await getCredentialsFromJwt({ jwt, isRegistered: false})
   } catch (e) {
     // Maybe the token expired or is just wrong -- give it one more try
     clearSavedGuestToken()
     const jwt = await getGuestTokenFromLocalStorage()
     return await getCredentialsFromJwt({ jwt, isRegistered: false })
   }
}

// Here is where it all comes together
const getSavedInstrumentsCredentials = async () => {
  try {
    return await getRegisteredUserCredentials()
  } catch (e) {
    return await getGuestUserCredentials()
  }
}

export { getSavedInstrumentsCredentials, clearSavedGuestToken }
